import {
  ACCEPT_INVITE_PAGE,
  ADD_CHANNEL_PAGE,
  ADD_TEAM_MEMBERS_PAGE,
  CHANNEL_OVERVIEW_PAGE,
  COMPLETED_PAGE,
  CUSTOMER_INFORMATION_PAGE,
  SETUP_EMAIL_PAGE,
  SIGNUP_PAGE,
  FACEBOOK_PAGE_SELECTION_PAGE,
} from './pages'

import { doFetchFacebookPages } from '../ducks/facebook'

const V1_ROUTES_CONFIG = {
  [SIGNUP_PAGE]: {
    route: {
      path: '/signup/f1',
    },
    handler: () => ({
      componentName: 'SignupPage',
      subapp: 'onboarding',
    }),
  },

  [CUSTOMER_INFORMATION_PAGE]: {
    route: {
      path: '/setup/f1/your-business',
    },
    handler: () => ({
      componentName: 'CustomerInformationPage',
      subapp: 'onboarding',
    }),
  },

  [CHANNEL_OVERVIEW_PAGE]: {
    route: {
      path: '/setup/f1/channels',
    },
    handler: () => ({
      componentName: 'ChannelOverviewPage',
      subapp: 'onboarding',
    }),
  },

  [ADD_TEAM_MEMBERS_PAGE]: {
    route: {
      path: '/setup/add-team',
    },
    handler: () => ({
      componentName: 'AddTeamMembersPage',
      subapp: 'onboarding',
    }),
  },

  [ADD_CHANNEL_PAGE]: {
    route: {
      path: '/setup/f1/add-channel',
    },
    handler: () => ({
      componentName: 'AddChannelPage',
      subapp: 'onboarding',
    }),
  },

  [SETUP_EMAIL_PAGE]: {
    route: {
      path: '/setup/f1/email-forwarding',
    },
    handler: () => ({
      componentName: 'SetupEmailPage',
      subapp: 'onboarding',
    }),
  },

  [COMPLETED_PAGE]: {
    route: {
      path: '/setup/f1/completed',
    },
    handler: () => ({
      componentName: 'CompletedPage',
      subapp: 'onboarding',
    }),
  },

  [ACCEPT_INVITE_PAGE]: {
    route: {
      path: '/users/invitation/accept',
      fromPath: segment => `${segment}`,
    },
    handler: () => ({
      componentName: 'AcceptInvitePage',
      subapp: 'onboarding',
    }),
  },

  [FACEBOOK_PAGE_SELECTION_PAGE]: {
    route: {
      path: '/facebook-pages',
      thunk: doFetchFacebookPages(),
    },
    handler: () => ({
      componentName: 'FacebookPageSelectionPage',
      subapp: 'onboarding',
    }),
  },
}

export default V1_ROUTES_CONFIG
